<div class="w-100 bg-brand">
  <div class="socials-band d-flex justify-content-center">
    <span class="margin-right-15">
      <app-social-facebook [badgeStyleClass]="'color-beige'"></app-social-facebook>
    </span>
    <span class="margin-right-15">
      <app-social-instagram [badgeStyleClass]="'color-beige'"></app-social-instagram>
    </span>
    <app-social-twitter [badgeStyleClass]="'color-beige'"></app-social-twitter>
  </div>
</div>
